export const JITSY_TUTOR_INTERVAL = 15000;
export const JITSY_ANALYTICS_INTERVAL = 1000;
// Number of people needed to start attention and emotion ai analyze
export const JITSY_AI_MIN_PARTICIPANT_COUNT = 3;

export const EU_BANNER_LINK = "https://rekomender2.wellms.io/";
